import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnsibleComponent } from './simple-icons-ansible.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnsibleComponent ],
    exports:      [ SimpleIconsAnsibleComponent ],
    bootstrap:    []
})
export class SimpleIconsAnsibleModule {}
